import { Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Location from "./components/pages/Location";
import NSAGFE from "./components/pages/NSAGFE";
import DisplayTherapist from "./components/pages/DisplayTherapist";
// import Footer from "./components/Footer";
function App() {
  const therapists = require('./data.json');
  return (
    <div className="App">
      <Navbar />
      <Outlet />
      <Routes>
        <Route path="/" element={<Home therapists={therapists} />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact therapists={therapists} />} />
        <Route path="/location" element={<Location />} />
        <Route path="/nsa" element={<NSAGFE />} />
        <Route
          path="/dt/:id"
          element={<DisplayTherapist therapists={therapists} />}
        />
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
